import { useEffect, useState } from "react";
import { Trophy, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

// Aparece al marcar la última serie que faltaba del ciclo. No cierra la semana
// por su cuenta: hasta que no se confirma, los checks siguen ahí para poder
// repasarlos.
export function CycleCompleteDialog() {
  const { state, cycleComplete, totals, startNextWeek, cancelRestTimer } = useApp();
  const [dismissed, setDismissed] = useState(false);

  // Al desmarcar una serie el ciclo deja de estar completo; el aviso debe poder
  // volver a salir cuando se complete de nuevo.
  useEffect(() => {
    if (!cycleComplete) setDismissed(false);
  }, [cycleComplete]);

  // Marcar la última serie dispara el descanso a la vez que este aviso, y
  // descansar entre series cuando ya no quedan series no tiene sentido.
  useEffect(() => {
    if (cycleComplete) cancelRestTimer();
  }, [cycleComplete, cancelRestTimer]);

  if (!state) return null;

  const week = state.week || 1;
  const open = cycleComplete && !dismissed;

  const handleStart = () => {
    startNextWeek();
    setDismissed(true);
    toast.success(`Semana ${week + 1} empezada`);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && setDismissed(true)}>
      <DialogContent className="glass-surface rounded-3xl border-0 w-[calc(100vw-2rem)] max-w-sm">
        <DialogHeader className="text-center items-center">
          <div
            className="h-14 w-14 rounded-2xl flex items-center justify-center mb-2"
            style={{ background: "rgba(52,211,153,0.14)", border: "1px solid rgba(52,211,153,0.3)" }}
          >
            <Trophy className="h-6 w-6 text-success" />
          </div>
          <DialogTitle className="text-foreground text-xl font-bold tracking-tight">
            ¡Semana {week} completada!
          </DialogTitle>
          <DialogDescription className="text-muted-foreground text-sm leading-relaxed">
            Has terminado las {totals.total} series de la rutina. Al empezar la semana{" "}
            {week + 1} se guardarán tus pesos y se quitarán todas las marcas.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button
            onClick={handleStart}
            className="w-full h-12 rounded-2xl bg-primary text-primary-foreground font-bold gap-2 fp-glow hover:bg-primary/90"
          >
            Empezar semana {week + 1}
            <ArrowRight className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            onClick={() => setDismissed(true)}
            className="w-full rounded-2xl text-muted-foreground hover:text-foreground"
          >
            Ahora no
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
